import client from '../token_client'

export const chromeBotSignInLink = (redirectUrl, email, locale) => {
  return client.post('chromebot/sign_in_link', {
    redirect_url: redirectUrl,
    email,
    locale
  })
}
